import { Unit } from './mealingredient';
import { MealIngredientCount } from './mealIngredientCount';
import { ShoppingItem } from './shoppingItem';

function isShoppingItem(item: MealIngredientCount | ShoppingItem): item is ShoppingItem {
  return 'category' in item;
}

function buildQuantityStringFromValues(unit: Unit, quantity: number, ingredientDisplayName: string) {
  const isInt = quantity === Math.floor(quantity);
  const maxFractionDigitstQuantity = isInt ? quantity : quantity.toFixed(2);

  if (unit === Unit.Unit) {
    return `${maxFractionDigitstQuantity} ${ingredientDisplayName}`;
  }
  return `${maxFractionDigitstQuantity}${unit} ${ingredientDisplayName}`;
}

export function buildQuantityString(item: MealIngredientCount | ShoppingItem, servingCount = 1): string {
  if (isShoppingItem(item)) {
    return buildQuantityStringFromValues(item.unit, item.quantity * servingCount, item.displayDescription);
  }

  const { unit, quantity, ingredientDisplayName } = item.displayData;
  return buildQuantityStringFromValues(unit, quantity * servingCount, ingredientDisplayName);
}
